import React from "react";
import { certifications } from "../mock";

const Certifications = () => {
  return (
    <section className="bg-brand-cream py-16 border-t border-black/5">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-brand-orange font-semibold tracking-[0.18em] text-sm uppercase mb-2">
          Trusted & Certified
        </p>
        <h2 className="text-center font-display font-extrabold text-brand-navy text-2xl md:text-3xl mb-10">
          Certifications & Accreditations
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {certifications.map((c) => (
            <div
              key={c.name}
              className="flex flex-col items-center justify-center gap-4 bg-white rounded-2xl px-4 py-8 border border-black/5 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all"
            >
              <img
                src={c.logo}
                alt={`${c.name} certification badge`}
                className="h-24 w-auto object-contain"
                loading="lazy"
              />
              <p className="font-display font-semibold text-brand-navy text-center text-sm">
                {c.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
